export const getBairradaData = () => ({
  name: "Bairrada",
  country: "Portugal",
  description: "La Bairrada est une région côtière réputée pour ses rouges puissants à base de Baga et ses mousseux de qualité.",
  type: "region",
  subregions: [
    { name: "Bairrada Clássica", area: "8,000 ha", percentage: "67%", description: "Cœur historique de la région" },
    { name: "Cantanhede", area: "2,000 ha", percentage: "17%", description: "Vins élégants" },
    { name: "Mealhada", area: "2,000 ha", percentage: "16%", description: "Vins fruités" }
  ],
  mapAreas: [
    { region: "Bairrada Clássica", x: 43, y: 36, color: "#4B164C", size: 5 },
    { region: "Cantanhede", x: 45, y: 38, color: "#6d2c7a", size: 3 },
    { region: "Mealhada", x: 47, y: 40, color: "#8a4a8a", size: 3 }
  ],
  statistics: {
    totalArea: "12,000 ha",
    production: "350,000 hl",
    wineries: "50+ caves",
    appellations: "3 sous-régions",
    exportPercentage: "25%"
  },
  characteristics: {
    climate: "Climat atlantique tempéré, influence océanique forte",
    soil: "Sols argilo-calcaires, sables, graviers",
    viticulture: "Cépage Baga dominant, vendanges manuelles"
  },
  wineStyles: {
    red: "Rouges puissants, tanniques, grande capacité de garde (Baga)",
    sparkling: "Mousseux de qualité, méthode traditionnelle"
  },
  history: "La Bairrada est réputée pour ses vins rouges de garde et ses mousseux depuis le XIXe siècle. Le cépage Baga y règne en maître.",
  foodPairing: "Cochon de lait rôti, fromages locaux, plats traditionnels de la côte portugaise"
}); 